module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_9016.f3ce2ed7.png";